import styles from './KnmChangeWarning.module.scss';
import { IOldNameControllingSubject } from '../../../APIPackage/KnmModule/interfaces/IOldNameControllingSubject';

interface IKnmChangeWarningProps {
  oldKnoOrganization?: string | null;
  oldNames?: IOldNameControllingSubject[] | null;
}

export const KnmChangeWarning = ({ oldKnoOrganization, oldNames }: IKnmChangeWarningProps) => {
  const oldKno = oldKnoOrganization?.trim();
  const isKnoChanged = !!oldKno;
  const hasOldNames = oldNames && oldNames.length > 0;

  if (!isKnoChanged && !hasOldNames) {
    return null;
  }

  let message: string;

  if (isKnoChanged && !hasOldNames) {
    message = 'Наименование органа контроля было изменено';
  } else {
    message = isKnoChanged
      ? 'Наименования органа контроля, контролируемого лица и объекта контроля были изменены'
      : 'Наименования контролируемого лица и объекта контроля были изменены';
  }

  return (
    <div className={styles.Hint} role="status">
      <span className={styles.Icon} aria-hidden="true">
        !
      </span>
      <span className={styles.Text}>{message}</span>
    </div>
  );
};
